var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsblue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 11.333,
    height: 15.403,
    viewBox: "0 0 11.333 15.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_174",
    "data-name": "Vrstva 174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_210",
    d: "M10.5 1.433a1.268 1.268 0 0 0-1.657 0L4.744 4.975A2.125 2.125 0 0 0 4 6.554V14.4a2.125 2.125 0 0 0 2.125 2.125h7.083a2.125 2.125 0 0 0 2.125-2.125V6.554a2.125 2.125 0 0 0-.708-1.608zM13.917 14.4a.708.708 0 0 1-.708.708H6.125a.708.708 0 0 1-.708-.708V6.554a.708.708 0 0 1 .248-.56l4-3.407 4 3.407a.708.708 0 0 1 .248.538z",
    className: "prefix__cls-1",
    style: {
      fill: "#3f66b3"
    },
    "data-name": "Trazado 210",
    transform: "translate(-4 -1.125)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Elipse_17",
    cx: 1.063,
    cy: 1.063,
    r: 1.063,
    className: "prefix__cls-1",
    style: {
      fill: "#3f66b3"
    },
    "data-name": "Elipse 17",
    transform: "translate(4.25 4.247)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsblue);
export default __webpack_public_path__ + "static/media/skillsblue.e6ff48fc.svg";
export { ForwardRef as ReactComponent };